import { useSelector } from "react-redux";
import SavedAlbumsPage from "./SavedAlbumsPage";
import { anyAvailableDevice } from "../reducers/devices";
import ConfirmPopup from "../components/popups/ConfirmPopup";
import { useOpenSpotifyApp } from "../hooks/others/useOpenSpotifyApp";
import { FULLY_BLOCKING_POPUP_ZINDEX as zIndex } from "../utils/constants/otherConstants";
import BlockingScreenLayer from "../components/common/containers/BlockingScreenLayer";
import { useLogOut } from "../hooks/authentication/useLogOut";
import { Logout } from "@mui/icons-material";
import TooManyRequestsBlocker from "../components/loading/TooManyRequestsBlocker";
import { getTooManyRequestsCooldown } from "../reducers/disablingProcesses";

const NoAvailableDevicesLayer = () => {
    const onClickButton = useOpenSpotifyApp();
    const onClickLogOut = useLogOut();

    const button = [
        {
            text: "Open Spotify",
            onClick: onClickButton
        },
        {
            text: "Log out",
            onClick: onClickLogOut,
            color: "error",
            endIcon: <Logout />
        }
    ];

    return (
        <BlockingScreenLayer zIndex={zIndex}>
            <div className="d-flex flex-row jc-center ai-center full-height">
                <ConfirmPopup 
                    title="Searching available devices..." 
                    message="Check your Spotify app or the Spotify web player" 
                    buttons={button} />
            </div>
        </BlockingScreenLayer>
    )
}

const PageWrapper = () => {
    const areAvailableDevices = useSelector(anyAvailableDevice);
    const tooManyRequestCooldown = useSelector(getTooManyRequestsCooldown);

    return (
        <>
        {
            <>
            {
                tooManyRequestCooldown > 0 ?
                <TooManyRequestsBlocker /> :
                !areAvailableDevices &&
                <NoAvailableDevicesLayer />
            }
            <SavedAlbumsPage />
            </>
        }
        </>
    )
}

export default PageWrapper;